
import Folder from "../../../assets/filled/Folder.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function FolderIcon({ className, dataTestid = "FolderIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Folder data-testid={dataTestid} className={classes} {...rest} />
  );
}
